import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { ServicesSunsetService } from '../services-sunset.service';
import { Reestablecer } from './recuperar.entity';

@Component({
  selector: 'app-reestablecer-clave',
  templateUrl: './reestablecer-clave.component.html',
  styleUrls: ['../../app.component.css']
})
export class ReestablecerClaveComponent implements OnInit {


  password: string;
  verificar: string;
  mensaje: string;
  exitoso: boolean;
  btnRecuperar: boolean;
  bpassword: boolean;
  bverificar: boolean;
  reestablecer: Reestablecer;
  idClave: string;
  validarRuta: boolean;

  constructor(private _servicios:ServicesSunsetService, private route:ActivatedRoute) {

    this.route.params.subscribe(parametro => {

      this.validarRuta = true;
      this.idClave = parametro['id'];

      this._servicios.validarToken(this.idClave).subscribe(
        (data:any) => {

          if(data.ok.toString() === 'false' ) {

            this.validarRuta = false;

          } else {

            if (data.consulta[0].id === 1) {

              this.validarRuta = true;

            } else {

              this.validarRuta = false;

            }


          }

        }

      );

    });


   }

  ngOnInit(): void {

    this.reestablecer = new Reestablecer();
    this.bpassword = true;
    this.bverificar = true;
    this.password="";
    this.mensaje = "";
    this.exitoso = false;
    this.btnRecuperar = true;
    this.verificar = "";


  }

  ojoVerificar() {

    this.bverificar = !this.bverificar;

  }


  
  ojoPassword() {

    this.bpassword = !this.bpassword;

  }


  validar() {

    if (this.password != this.verificar) {

      Swal.fire(
        'Notificación',
        'Las contraseñas no coinciden por favor verificar',
        'warning'
      );

      return;

    }

    this.btnRecuperar = false;

    this.reestablecer = new Reestablecer();

    this.reestablecer.id = this.idClave;
    this.reestablecer.clave = this.password;

    this._servicios.reestablecerPassword(this.reestablecer).subscribe(

      (data: any) => {


          if(data.ok.toString() === 'true') {

            Swal.fire(
              'Notificación',
              'Proceso realizado con éxito',
              'success'
            ).then((result) => {
              if (result.value) {
          
                this.exitoso = true;

              
                }}
                ).finally( ()=> {

                  this.exitoso = true;


                }
                  
                );

          
          
            return 


          } else {

            this.btnRecuperar = true
            this.mensaje = "Ha sucedido un error por favor intentelo más tarde."
            return
          }


      }


    )

  }

  DesactivarMensaje() {

    this.mensaje = "";

  }

}
